import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { ROLE_DEFAULT_ROUTES, ROLES } from '../constants/roles';

const AccessDenied: React.FC = () => {
  const navigate = useNavigate();
  const user = authService.getUser();
  const role = user?.role || ROLES.PACKER;
  const defaultRoute = ROLE_DEFAULT_ROUTES[role as keyof typeof ROLE_DEFAULT_ROUTES] || '/';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        p: 3,
      }}
    >
      <Paper
        sx={{
          p: 6,
          textAlign: 'center',
          maxWidth: 450,
        }}
      >
        <LockOutlined
          sx={{
            fontSize: 80,
            color: 'error.main',
            mb: 2,
          }}
        />
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Access Denied
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          You don't have permission to access this page. Please contact your administrator if you believe this is an error.
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate(defaultRoute)}
        >
          Go to Home
        </Button>
      </Paper>
    </Box>
  );
};

export default AccessDenied;
